import { enums } from "../enums/enum";

/**
 * Utility to get the label for a given enum value.
 * @param {string} enumName - The name of the enum (as in enums object).
 * @param {string} value - The value to look up.
 * @returns {string} The label for the value, or "N/A" if not found.
 */
export const getEnumLabel = (enumName, value) => {
  const enumData = enums[enumName];
  if (enumData) {
    const item = enumData.find((entry) => entry.value === value);
    return item ? item.label : "N/A";
  }
  return "N/A";
};

/**
 * Utility to get the value for a given enum label.
 * @param {string} enumName - The name of the enum (as in enums object).
 * @param {string} label - The label to look up.
 * @returns {string|null} The value for the label, or null if not found.
 */
export const getEnumValue = (enumName, label) => {
  const enumData = enums[enumName];
  if (enumData) {
    const item = enumData.find((entry) => entry.label === label);
    return item ? item.value : null;
  }
  return null;
};

/**
 * Utility to get all options for a given enum.
 * @param {string} enumName - The name of the enum (as in enums object).
 * @returns {Array} Array of {label, value} objects, or empty array if not found.
 */
export const getEnumOptions = (enumName) => {
  // Add debug logging for communication enum
  if (enumName === "communication") {
    console.log("Communication enum options:", enums.communication);
  }
  return enums[enumName] || [];
};
